<ds-modal [backgroundImage]="bgWrapperImage">
    <ds-modal-header>
        <button slot="end" ds-button-icon kind="tertiary" variant="flat" size="large" (click)="close()">
            <vn-icon name="theme-ex" />
        </button>
    </ds-modal-header>

    <ds-modal-content>
        @if (showStartScreen) {
            <div class="start-screen-container d-flex flex-column text-center">
                <div class="start-screen-content d-flex flex-column justify-content-center">
                    @if (content?.image; as image) {
                        <vn-image [src]="image.src" [alt]="image.alt" [width]="image.width" [height]="image.height" />
                    }
                    <div class="description" [vnDynamicHtml]="content?.text"></div>
                </div>
                <button ds-button kind="primary" variant="filled" size="large" (click)="startTour()">
                    {{ content?.resources?.StartTourButton }}
                </button>
            </div>
        }
        @if (!showStartScreen) {
            <div class="tour-items-container d-flex flex-column text-center">
                <div class="tour-items-content d-flex flex-column justify-content-center">
                    <vn-swiper [swiperOptions]="swiperConfig">
                        @for (child of tourItems | dsl | async; track trackByName(i, child); let i = $index) {
                            <div class="swiper-slide">
                                <ng-container *vnPageMatrix="child" />
                            </div>
                        }
                    </vn-swiper>
                </div>
                <div class="d-flex justify-content-between">
                    <div>
                        @if (indexSignal() > 0) {
                            <button ds-button kind="tertiary" variant="flat" size="large" (click)="previous()">
                                {{ content.resources.PreviousButton }}
                            </button>
                        }
                    </div>
                    @if (!showGotItButton && tourItems.length > 1) {
                        <button ds-button kind="primary" variant="filled" size="large" (click)="next()">
                            {{ content.resources.NextButton }}
                        </button>
                    }
                    @if (showGotItButton) {
                        <button ds-button kind="primary" variant="filled" size="large" (click)="close(true)">
                            {{ content.resources.GotItButton }}
                        </button>
                    }
                    @if (!showGotItButton && tourItems.length === 1) {
                        <button ds-button kind="primary" variant="filled" size="large" (click)="close(true)">
                            {{ content.resources.GotItButton }}
                        </button>
                    }
                </div>
            </div>
        }
    </ds-modal-content>
</ds-modal>
